export const getClientIdByHotelCode = (hotelCode) => hotelCodeMap[hotelCode + ""];

export const getEndpointByHotelCode = (hotelCode) => hotelCodeEndpointMap[hotelCode + ""];

const clientIds = {
  hyde: process.env.REACT_APP_FLOW_HYDE_CLIENT_ID,
  sls: process.env.REACT_APP_FLOW_SLS_CLIENT_ID,
  mondrian: process.env.REACT_APP_FLOW_MONDRIAN_CLIENT_ID,
  morgans: process.env.REACT_APP_FLOW_MORGANS_CLIENT_ID,
  delano: process.env.REACT_APP_FLOW_DELANO_CLIENT_ID,
  sanderson: process.env.REACT_APP_FLOW_SBE_CLIENT_ID,
  sbe: process.env.REACT_APP_FLOW_SBE_CLIENT_ID
};

const endpoints = {
  hyde: process.env.REACT_APP_FLOW_HYDE_ENDPOINT_URL,
  sls: process.env.REACT_APP_FLOW_SLS_ENDPOINT_URL,
  mondrian: process.env.REACT_APP_FLOW_MONDRIAN_ENDPOINT_URL,
  morgans: process.env.REACT_APP_FLOW_MORGANS_ENDPOINT_URL,
  delano: process.env.REACT_APP_FLOW_DELANO_ENDPOINT_URL,
  sanderson: process.env.REACT_APP_FLOW_SBE_ENDPOINT_URL,
  sbe: process.env.REACT_APP_FLOW_SBE_ENDPOINT_URL
};

const hotelCodeMap = {
  '61890': clientIds.mondrian,
  C0B7: clientIds.mondrian,
  '1614': clientIds.sls,
  '79606': clientIds.sls,
  B5C4: clientIds.sls,
  B5B2: clientIds.sls,
  B5B0: clientIds.sls,
  B723: clientIds.sls,
  B9T8: clientIds.sls,
  B5C3: clientIds.sls,
  B5C8: clientIds.sls,
  B8R1: clientIds.delano,
  B7G6: clientIds.mondrian,
  B771: clientIds.mondrian,
  B5C1:  clientIds.mondrian,
  '74836': clientIds.mondrian,
  '61889': clientIds.mondrian,
  B7F8: clientIds.mondrian,
  B8Y4: clientIds.mondrian,
  B7J3: clientIds.mondrian,
  B7G5: clientIds.mondrian,

  C4B0: clientIds.hyde,

  '3167': clientIds.sbe,
  B6V5: clientIds.sbe,
  B5D4: clientIds.sbe,
  B5D3: clientIds.sbe,
  B8X5: clientIds.sbe,
  B8Y1: clientIds.sbe,
  B938: clientIds.sbe,
}

const hotelCodeEndpointMap = {
  '61890': endpoints.mondrian,
  C0B7: endpoints.mondrian,
  '1614': endpoints.sls,
  '79606': endpoints.sls,
  B5C4: endpoints.sls,
  B5B2: endpoints.sls,
  B5B0: endpoints.sls,
  B723: endpoints.sls,
  B9T8: endpoints.sls,
  B5C3: endpoints.sls,
  B5C8: endpoints.sls,
  B8R1: endpoints.delano,
  B7G6: endpoints.mondrian,
  B771: endpoints.mondrian,
  B5C1: endpoints.mondrian,
  '74836': endpoints.mondrian,
  '61889': endpoints.mondrian,
  B7F8: endpoints.mondrian,
  B8Y4: endpoints.mondrian,
  B7J3: endpoints.mondrian,
  B7G5: endpoints.mondrian,

  C4B0: endpoints.hyde,

  '3167': endpoints.sbe,
  B6V5: endpoints.sbe,
  B5D4: endpoints.sbe,
  B5D3: endpoints.sbe,
  B8X5: endpoints.sbe,
  B8Y1: endpoints.sbe,
  B938: endpoints.sbe,
}



// WEBPACK FOOTER //
// ./src/utilities/property/getClientIdByHotelCode.js